<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view/>
  </div>
</template>
<script>
 
// import { defineComponent } from '@vue/composition-api'

// export default defineComponent({
//   setup() {
    
//   },
// })
export default{
  mounted(){
    // console.log(window.navigator.userAgent)
    function IsPc(){
        let userAgentInfo = navigator.userAgent;
        let Agents = ['Android','iPhone','SymbianOS','Windows Phone','iPod'];
        let flag = true;
        for(let i = 0;i < Agents.length;i++){
            if(userAgentInfo.indexOf(Agents[i])>0){
                flag = false;
                break;
            }
        }
        if(window.screen.width>=768){
            flag = true;
        }
        return flag;
    }
    let pc=IsPc()
    // console.log(pc)
    if(pc){
      // alert(1)
      // this.$router.replace('/en');

      //页面初始化，针对屏幕不是1920*1080的页面尺寸
  let designSize = 1920; // 设计图尺寸            
    let html = document.documentElement;            
    let wW = html.clientWidth;// 窗口宽度
     
    if(wW<1920){
      let rem = wW * 100 / designSize; 
      document.documentElement.style.fontSize = rem + 'px';
    }
    // else if(wW<1280){
    //   // alert(0)
    //   let rem = 1280 * 100 / designSize; 
    //   document.documentElement.style.fontSize = rem + 'px';
    // }
    else{
      let rem = 1920 * 100 / designSize; 
      document.documentElement.style.fontSize = rem + 'px';
    }              
    // 页面缩放时 font-size 的调整        
    window.onresize=function (){           
        let designSize = 1920; // 设计图尺寸            
        let html = document.documentElement;            
        let wW = html.clientWidth;// 窗口宽度
        if(wW<1920){
          let rem = wW * 100 / designSize; 
        document.documentElement.style.fontSize = rem + 'px';
        }
        // else if(wW<1280){
        //   // alert(0)
        //   let rem = 1280 * 100 / designSize; 
        //   document.documentElement.style.fontSize = rem + 'px';
        // }
        else{
          let rem = 1920 * 100 / designSize; 
          document.documentElement.style.fontSize = rem + 'px';
        }
    };
    var type=navigator.appName
    if (type=="Netscape")
    var lang = navigator.language
    else
    var lang = navigator.userLanguage
    //cut down to first 2 chars of country code
    // var lang = lang.substr(0,2)
    // 英语
    // if (lang == "en")
    // window.location.replace('url')
    // 简体中文
    // console.log('路由',this.$route)
    // if (lang == "zh-TW"){
    //   this.$router.replace('/cht')
    // }
    // // // 繁体中文
    // else if (lang == "zh-CN"){
    //   this.$router.replace('/cht')
    // // window.location.replace('url')
    // }
    // // // 俄语
    // else if (lang == "ru"){
    //   this.$router.replace('/rus')
    // }
    // // 除上面所列的语言
    // else{
    //   // alert(4)
      
    //   console.log('当前语言',type,lang)
    //   this.$router.replace('/en')
    // }
    }
    if(!pc){
      // alert(0)
      // this.$router.replace('/m-en')
      //页面初始化，针对屏幕不是1920*1080的页面尺寸
  let designSize = 750; // 设计图尺寸            
    let html = document.documentElement;            
    let wW = html.clientWidth;// 窗口宽度
     
    if(wW<1920&&wW>1280){
      let rem = wW * 100 / designSize; 
      document.documentElement.style.fontSize = rem + 'px';
    }else if(wW<1280){
      // alert(0)
      let rem = wW * 100 / designSize; 
      document.documentElement.style.fontSize = rem + 'px';
    }else{
      let rem = 1920 * 100 / designSize; 
      document.documentElement.style.fontSize = rem + 'px';
    }              
    // 页面缩放时 font-size 的调整        
    window.onresize=function (){           
        let designSize = 750; // 设计图尺寸            
        let html = document.documentElement;            
        let wW = html.clientWidth;// 窗口宽度
        if(wW<1920&&wW>1280){
          let rem = wW * 100 / designSize; 
        document.documentElement.style.fontSize = rem + 'px';
        }else if(wW<1280){
          // alert(0)
          let rem = wW * 100 / designSize; 
          document.documentElement.style.fontSize = rem + 'px';
        }else{
          let rem = 1920 * 100 / designSize; 
          document.documentElement.style.fontSize = rem + 'px';
        }
    };
     var type=navigator.appName
    if (type=="Netscape")
    var lang = navigator.language
    else
    var lang = navigator.userLanguage
    //cut down to first 2 chars of country code
    // var lang = lang.substr(0,2)
    // 英语
    // if (lang == "en")
    // window.location.replace('url')
    // 简体中文
    // console.log(this.$route)
  //   if (lang == "TW"){
  //   this.$router.replace('/m-chs')
  // }
  //   // // 繁体中文
  //   else if (lang == "zh"){
  //     this.$router.replace('/m-chs')
  //   // window.location.replace('url')
  // }
  //   // // 俄语
  //   else if (lang == "ru"){
  //     this.$router.replace('/m-rus')
  //   }
  //   // 除上面所列的语言
  //   else{
  //     // alert(9)
  //     this.$router.replace('/m-en')
  //   }
    }
    // console.log(this.$router)
    
  }
}

</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
.img2-box{
  cursor: pointer;
  position: absolute;
  left: 50%;
  // bottom: 1.7rem;
  bottom: 3rem;
  transform: translate(-50%, 0);
  img{
    animation: vGo 2s linear infinite;
    width: 1.14rem;
    height: 1.24rem;
  }
}
@keyframes vGo{
 0%{transform: scale(1.1);-webkit-transform: scale(1.1);}
 50%{transform: scale(1);-webkit-transform: scale(1);}
 100%{transform: scale(1.1);-webkit-transform: scale(1.1);}
}
// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }

// .my-bullet{
//   z-index: 9999999999999 !important;
//     width: 1rem !important;
//     height: 1rem!important;
//     // display: inline-block;
//     border-radius: 50%!important;
//     background: #B7B6B9!important;
//     &:nth-child(2){
//       margin: 0 0.1rem!important;
//     }
//   }
//   .my-bullet-active{
//     background: #FD882E!important;
//   }

body * {
  box-sizing: border-box;
  flex-shrink: 0;
  // margin: 0 !important;

}
body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
  margin: 0 auto !important;
  background: #21242d;
  // overflow-x: hidden;
}
button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}
.flex-col {
  display: flex;
  flex-direction: column;
  max-width: 1920px;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}

</style>
